export const firmware_keys = [
    'access',
    'user_id',
    'device_type',
    'name',
    'individual_device_name',
    'id',
    'declined_firmware_update_versions',
    'z3k_config',
    'firmware_version',
    'online',
];
